import { render, staticRenderFns } from "./FloorsTable.vue?vue&type=template&id=a3b65114&"
import script from "./FloorsTable.vue?vue&type=script&lang=js&"
export * from "./FloorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports